import { apiSlice } from '../../store/apiSlice';

export const extendedApiSlice = apiSlice
  .enhanceEndpoints({ addTagTypes: ['GetInTouch'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getInTouch: builder.mutation({
        query: (formData) => ({
          url: 'support/register-fishery-interest',
          method: 'post',
          data: formData,
        }),
      }),
      requestDemo: builder.mutation({
        query: (formData) => ({
          url: 'support/register-fishery-demo-request',
          method: 'post',
          data: formData,
        }),
      }),
    }),
  });

export const { useGetInTouchMutation, useRequestDemoMutation } =
  extendedApiSlice;
